import { createContext, useState } from 'react';

export const SearchParamsContext = createContext();

export const SearchParamsProvider = ({ children }) => {
  //current search params
  const [searchParams, setSearchParams] = useState(window.location.search);

  const searchParamsObject =
    searchParams &&
    searchParams
      .replace('?', '')
      .split('&')
      .map((p) => p.split('='))
      .reduce((acc, p) => ({ ...acc, [p[0]]: p[1] }), {});

  const addParams = (newParams) => {
    const params = new URLSearchParams(window.location.search);

    newParams = Object.keys(newParams).forEach((k) => {
      params.set(k, newParams[k]);
    });

    window.history.replaceState(null, null, `?${params}`);
    setSearchParams(window.location.search);
  };

  const removeParam = (key) => {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);
    window.history.replaceState(null, null, `?${params}`);
    setSearchParams(window.location.search);
  };

  const clearParams = () => {
    window.history.replaceState(null, null, `?`);
    setSearchParams(window.location.search);
  };

  return (
    <SearchParamsContext.Provider value={{ searchParams: searchParamsObject, addParams, removeParam, clearParams }}>
      {children}
    </SearchParamsContext.Provider>
  );
};
